import React from "react";
import styled from "styled-components";
import { SimpleTextInput } from "./simpleTextInput";

interface NationalityDatalistProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
	id: string;
	value: string | undefined;
	onChange: (v: string) => void;
	placeholder?: string;
	disabled?: boolean;
}
export const NationalityDatalist: React.FC<NationalityDatalistProps> = ({
	id,
	value,
	onChange,
	placeholder,
	disabled,
	...htmlProps
}) => {
	return (
		<Container {...htmlProps}>
			<SimpleTextInput
				placeholder={placeholder}
				value={value ?? ""}
				list={id}
				onChange={(v) => onChange(v)}
				isApplication
			/>
		</Container>
	);
};

const Container = styled.div``;
